import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Servico } from "@interfaces/service";
import {
  formatarCnae,
  formatarItemLc116
} from "src/app/utils/codigos-servico.util";
import {
  joinFaltantes,
  servicoCamposFaltantes
} from "src/app/utils/parametrizacao.util";

@Component({
  selector: "app-service-card",
  templateUrl: "./service-card.component.html",
  styleUrls: ["./service-card.component.scss"]
})
export class ServiceCardComponent {
  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  /** Pedido de ativar (true) ou inativar (false) o serviço. */
  @Output() toggleAtivo = new EventEmitter<boolean>();
  @Input() service?: Servico;

  get ativo() {
    return this.service?.ativo !== false;
  }

  get preCadastroCnae() {
    return this.service?.origem === "CNAE_RECEITA";
  }

  /** Rascunho importado pelo CNAE: o que ainda falta para emitir. */
  get faltantes() {
    return servicoCamposFaltantes(this.service);
  }

  get parametrizado() {
    return this.faltantes.length === 0;
  }

  get faltantesTexto() {
    return joinFaltantes(this.faltantes);
  }

  /** Item LC 116 no formato 00.00.00 ou 00.00 (o cadastro grava só dígitos). */
  get codigoFormatado() {
    return formatarItemLc116(this.service?.codigo);
  }

  /** CNAE no formato 0000-0/00. */
  get cnaeFormatado() {
    return formatarCnae(this.service?.cnae);
  }

  get temAliquota() {
    const aliquota = this.service?.iss?.aliquota;
    return (
      aliquota !== null &&
      aliquota !== undefined &&
      String(aliquota).trim() !== ""
    );
  }
}
